import { PressableNeolexon } from '@/components/PressableNeolexon';
import { useEffect, useState } from 'react';
import { Image, View } from 'react-native';
import AVATAR from '../../../assets/avatars';
import { appTheme } from '@/config/colors';

const avatarList = [
  {
    url: 'modules/patients/client/img/avatar/avatar1.png',
    name: 'avatar1',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar2.png',
    name: 'avatar2',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar3.png',
    name: 'avatar3',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar4.png',
    name: 'avatar4',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar5.png',
    name: 'avatar5',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar6.png',
    name: 'avatar6',
  },

  {
    url: 'modules/patients/client/img/avatar/avatar7.png',
    name: 'avatar7',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar8.png',
    name: 'avatar8',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar9.png',
    name: 'avatar9',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar10.png',
    name: 'avatar10',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar11.png',
    name: 'avatar11',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar12.png',
    name: 'avatar12',
  },
];

export function AvatarList({ onAvatarPress, defaultAvatar }) {
  const [checked, setChecked] = useState(null);

  function onChecked(index, avatar) {
    setChecked(index);
    onAvatarPress(avatar);
  }

  function getImageNumber(url) {
    let imageUrlEnding = url.split('avatar');
    let imageNumber = imageUrlEnding[imageUrlEnding.length - 1].split('.')[0];
    return parseInt(imageNumber);
  }

  useEffect(() => {
    if (defaultAvatar) {
      setChecked(getImageNumber(defaultAvatar));
    }
  }, [defaultAvatar]);

  return (
    <View>
      <View
        style={{ flexDirection: 'row', justifyContent: 'space-around', gap: 8 }}
      >
        {avatarList.map((item, index) => {
          const avatarArray = item.url.split('/');
          const image =
            avatarArray?.length &&
            avatarArray[avatarArray?.length - 1].split('.')[0];
          const source = AVATAR[image];

          return (
            <PressableNeolexon
              style={{ flex: 1 }}
              key={index}
              onPress={() => {
                onChecked(getImageNumber(item.url), item.url);
              }}
            >
              <View
                style={{
                  flex: 1,
                  aspectRatio: 1,
                  borderRadius: 200,
                  width: '100%',
                }}
              >
                <Image
                  source={source}
                  style={[
                    { flex: 1, resizeMode: 'cover', width: null, height: null },
                    getImageNumber(item.url) === checked
                      ? {
                          borderWidth: 4,
                          borderRadius: 100,
                          borderColor: appTheme.primary,
                          opacity: 1,
                        }
                      : {
                          opacity: 0.6,
                        },
                  ]}
                  resizeMode={'contain'}
                />
              </View>
            </PressableNeolexon>
          );
        })}
      </View>
    </View>
  );
}
